import React from "react";
import { Navigate } from "react-router-dom";
import storage from "../utils/storage";


const ProtectedRoute = ({ requiredPermissions = [], children }) => {
  let user = null;
  try {
    user = JSON.parse(storage.getItem("user"));
  } catch {
    user = null;
  }
  const token = storage.getItem("token");

  // Debug logs
  // console.log("[ProtectedRoute] user:", user);
  // console.log("[ProtectedRoute] token:", token);
  // console.log("[ProtectedRoute] requiredPermissions:", requiredPermissions);
  // console.log("[ProtectedRoute] user.permissions:", user?.permissions);

  // Not logged in
  if (!user || !token) return <Navigate to="/candidate/signin" />;

  // Permission check
  if (
    requiredPermissions.length > 0 &&
    user.role !== "superadmin" &&
    !requiredPermissions.some((perm) => user.permissions?.includes(perm))
  ) {
    console.warn("[ProtectedRoute] Permission denied. Redirecting to /browse-jobs");
    return <Navigate to="/browse-jobs" />;
  }

  return children;
};

export default ProtectedRoute;
